<template>
  <div class="">
    <el-upload
      :on-exceed="handleExceed"
      :limit="4"
      :before-upload="beforeUpload"
      :file-list="upList"
      ref="pictureUpload"
      action="#"
      list-type="picture-card"
      :http-request="request"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>

          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="imgRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    toPicture: Array
  },
  data() {
    //这里存放数据

    return {
      upList: [],
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false
    };
  },
  watch: {
    toPicture(val) {
      this.upList = val;

      if (val.length != 0) {
        val.forEach(e => {
          let picture = {
            name: e.name,
            UpName: e.name
          };
          this.fileList.push(picture);
        });
      }
    },
    fileList(val) {
      this.$emit("fromChild", val);
    }
  },

  //方法集合

  methods: {
    handleExceed() {
      this.$message.warning(`当前只可选择 4个文件`);
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpeg";
      const extension2 = testmsg === "png";
      const extension3 = testmsg === "jpg";
      const extension4 = testmsg === "bmp";
      const extension5 = testmsg === "tif";
      const extension6 = testmsg === "gif";
      const extension7 = testmsg === "pcx";
      const extension8 = testmsg === "tga";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5 &&
        !extension6 &&
        !extension7 &&
        !extension8
      ) {
        this.$message({
          message: "上传文件不是图片格式!",
          type: "warning"
        });
      }
      // 也可以在这里增加文件大小限制
      // if(!isLt2M) {
      //     this.$message({
      //         message: '上传文件大小不能超过 10MB!',
      //         type: 'warning'
      //     });
      // }
      // return (extension || extension2) && isLt2M
      console.log("11");
      return (
        extension ||
        extension2 ||
        extension3 ||
        extension4 ||
        extension5 ||
        extension6 ||
        extension7 ||
        extension8
      );
    },
    async request(param) {
      let file = param.file;
      // FormData 对象
      var form = new FormData();
      // 文件对象
      form.append("file", file); // 通过append向form对象添加数据

      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const { data: dt } = await this.$http.post(
        "general/upload",
        form,
        config
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      let picture = {
        name: param.file.name,
        UpName: dt.data.result
      };
      this.fileList.push(picture);

      this.$message({
        message: "上传成功",
        type: "success"
      });
    },
    //删除列表
    imgRemove(file) {
      this.$refs.pictureUpload.handleRemove(file);

      this.fileList.forEach((e, i) => {
        if (e.name === file.name) {
          this.fileList.splice(i, 1);
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
</style>
